import { create } from 'zustand';

/**
 * Command-palette open state.
 *
 * Lifted out of `<CommandPalette>` so chrome elements (the top-bar search
 * button + the mobile search icon in `ForgeShell`) can open the palette
 * imperatively — the palette itself still owns the Cmd/Ctrl+K toggle.
 */
interface CommandPaletteState {
  open: boolean;
  setOpen: (open: boolean) => void;
  toggle: () => void;
}

export const useCommandPalette = create<CommandPaletteState>((set) => ({
  open: false,
  setOpen: (open) => set({ open }),
  toggle: () => set((s) => ({ open: !s.open })),
}));
